export default __webpack_public_path__ + "static/media/balboa.1a5bcaea.png";